module.exports = __webpack_public_path__ + "static/img/bg91.2e965c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg91.png
// module id = CjoT
// module chunks = 0